import React, { useEffect, useState } from 'react';
import { View } from 'react-native';

import LearnHub from '@/components/Learn/LearnHub';
import MetaHead from '@/components/MetaHead';
import { LEARN_HUB } from '@/constants/learnCurriculum';
import { GUIDE_DATE_MODIFIED } from '@/constants/guideSeoDates';
import { learnHubStructuredData } from '@/lib/docsLearnStructuredData';
import { guideApi } from '@/lib/guideApi';

export default function LearnHubPage() {
  const [page, setPage] = useState(null);

  useEffect(() => {
    let cancelled = false;
    guideApi.getPage('learn', 'index').then((data) => {
      if (!cancelled) setPage(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const title = LEARN_HUB.seoTitle;
  const description = LEARN_HUB.seoDescription;
  const keywords = LEARN_HUB.seoKeywords;

  return (
    <View>
      <MetaHead
        title={title}
        description={description}
        canonical="/learn"
        keywords={keywords}
        type="website"
        lastModified={page?.updatedAt ? new Date(page.updatedAt).toISOString() : GUIDE_DATE_MODIFIED}
        structuredData={learnHubStructuredData()}
      />
      <LearnHub />
    </View>
  );
}
